import { request } from "@/interface/helper";

const str = "setting";

export const setting = {
  [`${str}`]: {
    getUserInformation: data => request({ data, method: "get", url: "/user/info.json" }),
    realname: data => request({ data, method: "get", url: "/user/realname.json" }),
    viewgooglekey: data => request({ data, method: "get", url: "/user/viewgooglekey" }),
    vierfygooglecode: data => request({ data, method: "get", url: "/user/vierfygooglecode" }),
    pwdset: data => request({ data, method: "get", url: "/user/pwdModify.json" }),
    getList: data => request({ data, method: "post", url: "/user/modify" }),
    change: data => request({ data, method: "post", url: "/user/reset" }),
    detail: data => request({ data, method: "get", url: "/withdraw/detail" }),
    del: data => request({ data, method: "post", url: "/user/remove" }),
    batch: options => request({ method: "post", url: "/domain/batch", ...options })
  }
};
